<template>
  <div class="report-radar">
    <svg :viewBox="'-45 0 ' + (size + 90) + ' ' + size" class="radar-svg" role="img" aria-label="表达能力雷达图">
      <title>表达能力雷达图</title>
      <polygon v-for="(r, index) in gridRadii" :key="'grid-' + index" :points="polygonPoints(axes.map(() => r))" class="radar-grid" />
      <line
        v-for="(axis, index) in axes" :key="'axis-' + index" :x1="center"
        :y1="center" :x2="point(index, radius).x" :y2="point(index, radius).y"
        class="radar-axis"
      />
      <polygon :points="polygonPoints(valueRadii)" class="radar-area" />
      <circle
        v-for="(value, index) in valueRadii" :key="'dot-' + index" :cx="point(index, value).x"
        :cy="point(index, value).y" r="3" class="radar-dot"
      />
      <text
        v-for="(axis, index) in axes" :key="'label-' + index" :x="labelPoint(index).x"
        :y="labelPoint(index).y" :text-anchor="labelAnchor(index)" class="radar-label"
      >{{ axis.name }} {{ axis.value }}</text>
    </svg>
  </div>
</template>

<script>
// 移植 App RadarChart 的几何与量程，只绘制服务端保存的表达维度分数。
export default {
  name: 'ReportRadar',
  props: { data: { type: Object, default: () => ({}) }, max: { type: Number, default: 5 } },
  data() {
    return { size: 240, center: 120, radius: 78, gridRadii: [78, 58.5, 39, 19.5] }
  },
  computed: {
    axes() { return Object.keys(this.data || {}).map(name => ({ name, value: Number(this.data[name]) || 0 })) },
    valueRadii() { return this.axes.map(axis => Math.min(1, Math.max(0, axis.value / (this.max || 5))) * this.radius) }
  },
  methods: {
    point(index, radius) {
      const angle = Math.PI * 2 * index / (this.axes.length || 1) - Math.PI / 2
      return { x: this.center + radius * Math.cos(angle), y: this.center + radius * Math.sin(angle) }
    },
    polygonPoints(radii) { return radii.map((radius, index) => `${this.point(index, radius).x},${this.point(index, radius).y}`).join(' ') },
    labelPoint(index) { const point = this.point(index, this.radius + 20); return { x: point.x, y: point.y + 4 } },
    labelAnchor(index) {
      const point = this.point(index, this.radius)
      return Math.abs(point.x - this.center) < 2 ? 'middle' : point.x > this.center ? 'start' : 'end'
    }
  }
}
</script>

<style scoped>
.report-radar { display: flex; justify-content: center; }
.radar-svg { width: 100%; max-width: 360px; }
.radar-grid { fill: none; stroke: #e6e8eb; stroke-width: 1; }
.radar-axis { stroke: #e6e8eb; stroke-width: 1; }
.radar-area { fill: rgba(62, 175, 144, 0.15); stroke: #3eaf90; stroke-width: 1.5; }
.radar-dot { fill: #3eaf90; }
.radar-label { font-size: 11px; fill: #507c69; }
</style>
